// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.layout_container {
  max-width: 100%;
  min-height: 49vh;
}

.page-ht {
  min-height: 90vh;
}`, "",{"version":3,"sources":["webpack://./src/layout/main-layout/mainLayout.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,gBAAA;AACJ;;AACA;EACI,gBAAA;AAEJ","sourcesContent":[".layout_container{\n    max-width: 100%;\n    min-height: 49vh;\n}\n.page-ht{\n    min-height: 90vh;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
